import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginModel, LanguageModel } from './login.model';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LoginService {

    
    constructor(private http: HttpClient) { }

  

    login(data): Observable<LoginModel> {
        const url = environment.token_url + 'connect/token';
        return this.http.post(url, data).pipe(map((response: LoginModel) => {
            return response;
        }));
    }

    logout(): Observable<number> {
        const url = environment.url + 'Logout';
        return this.http.post(url, {}).pipe(map((response: number) => {
            return response;
        }));
    }

    removePushNotificationToken(token): Observable<any> {
        const url = environment.notification_url + 'notification/token/unsubscribe/' + token;
        return this.http.delete(url).pipe(map((response) => {
            return response;
        }));
    }

    ssoLogin(data): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json-patch+json',
            'Accept': 'application/json'
            });
        const url = environment.url + 'User/sso/login';
        return this.http.post(url, JSON.stringify(data), { headers }).pipe(map((response) => {
            return response;
        }));
    }
}
